import { BOARD_SIZE } from '../constants';
import type { ICell, TShip } from '../types';

/**
 * Returns all cells adjacent to the ship (8-neighborhood), within board bounds,
 * excluding cells that belong to the ship.
 */
export function getCellsAroundShip(ship: TShip): ICell[] {
  const shipSet = new Set<string>();
  for (const { col, row } of ship) {
    shipSet.add(`${row},${col}`);
  }
  const out: ICell[] = [];
  const seen = new Set<string>();

  for (const { col, row } of ship) {
    for (let dr = -1; dr <= 1; dr++) {
      for (let dc = -1; dc <= 1; dc++) {
        if (dr === 0 && dc === 0) continue;
        const r = row + dr;
        const c = col + dc;
        if (r < 0 || r >= BOARD_SIZE || c < 0 || c >= BOARD_SIZE) continue;
        const key = `${r},${c}`;
        if (shipSet.has(key) || seen.has(key)) continue;
        seen.add(key);
        out.push({ row: r, col: c });
      }
    }
  }
  return out;
}
